(function () {
    "use strict";

    angular.module('iMatApp')
        .controller('IssuesController', IssuesController);

    IssuesController.$inject = ['$scope', 'mainWorkspace', 'productSalesPriceProvider', 'issueTrackEventService'];

    function IssuesController($scope, mainWorkspace, productSalesPriceProvider, issueTrackEventService) {
        var vm = this;
        vm.getIssue = getIssue;

        activate();

        // ----------------------------------- Public functions -----------------------------

        function getIssue() {
            if (mainWorkspace.issue) {
                return mainWorkspace.issue;
            }

            if (mainWorkspace.product.model.issue) {
                return mainWorkspace.product.model.issue;
            }

            var salesPrice = getSalesPrice();
            if (salesPrice && salesPrice.issue) {
                return salesPrice.issue;
            }

            return null;
        }

        // ----------------------------------- Private functions ----------------------------

        function activate() {
            issueTrackEventService.runIssueWatching($scope, getIssue);
        }

        function getSalesPrice() {
            return productSalesPriceProvider.getSalesPrice(mainWorkspace.product);
        }

    }
})();